const slidesLocal = {
  slides: [
    {
      stack: [
        {
          menu: true,
          title: "Cover",
          link: "cover",
          bg: "https://firebasestorage.googleapis.com/v0/b/use-captiv.appspot.com/o/1-cover.svg?alt=media&token=ec26b3c3-9617-4dae-96ea-7963d521d452",
          cols: [
            {
              xs: "1",
              sm: "1",
              md: "1",
              lg: "1",
              class: "start-xs start-sm center-md center-lg flex flexCenterLg",
              blocks: [],
            },
            {
              xs: "12",
              sm: "12",
              md: "1",
              lg: "1",
              class: "start-xs start-sm center-md center-lg flex flexCenterLg hideLarge",
              blocks: [
                {
                  value:
                    "<svg version='1.1' class='annotation slideIcon' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 92.9 117.4'> <path style='fill:#000FFF;' d='M83.2,54.3c-2.7,4.1-6,7.5-9.7,10.6c-3.6,3-8,5.8-10.1,10.1c-3.1,6.3-3.3,11.6-10.7,14 c-3.8,1.2-7.7,2-11.5,2.8c-0.2,0-0.3,0.1-0.5,0.1c1.4,0.3,2.8,0.6,4.1,0.9c3.7,0.8,9.9,0.7,12.3,4c0.7,0.9,0.4,2.5-0.4,3.3 c-2.5,2.3-6.7,1.4-9.9,1.6c-1.4,0.1-2.7,0.2-4.1,0.3c2.3,0.5,4.7,0.9,6.9,1.7c3.1,1.1,5.1,4.9,2.5,7.7c-3.6,3.9-13.7,3.5-18.5,2.9 c-3.4-0.4-3.4-5.9,0-5.4c2.9,0.4,5.8,0.3,8.8-0.1c0.5-0.1,1.2-0.3,1.9-0.5c-1.4-0.4-2.7-0.9-3.4-1.1c-4-0.9-10.7-1-13.3-4.5 c-0.8-1-0.3-2.5,0.4-3.3c2-2.3,6.6-2.2,9.8-2.4c-3.5-0.4-8.3-0.9-10.2-3.2c-1-1.2-1-2.6,0-3.8c1.8-2.2,6.3-2.2,8.9-2.7 c3.7-0.8,7.5-1.6,11.2-2.5c2.9-0.7,6-1.1,7.7-3.8c1.9-3.2,2.2-7.1,4.2-10.3c4.4-6.8,12.4-10.5,17.3-16.9c5.5-7.2,8.5-16.5,6.7-25.5 C79.8,8.1,57.8,6.8,41.2,8.7c-9.1,1-18.3,4-24.7,10.9c-6.2,6.8-9,16.6-7.5,25.7c1.7,9.5,7.3,15.6,14.8,21.1c5.4,4,9.4,9.3,8,16.3 c-0.7,3.4-5.9,2-5.2-1.4C28,74.1,20,70.7,15.5,67c-4-3.3-7.1-7.6-9.2-12.3c-4.1-9.2-4-19.6-0.1-28.8C13.8,8.1,32.6,3,50.3,2.7 c8.9-0.1,18.4,0.6,26.2,5.4c7.4,4.6,11.7,12.4,12.9,20.8C90.5,37.8,88.1,46.8,83.2,54.3z M56.5,36.2c-1.9,0.8-3,2.4-4.8,0.2 c-0.3-0.3-0.7-1.9-0.9-2.3c-1-2.1-3.8-1.2-4.5,0.6c-1.3,3.4-5.4,3.9-7.2,0.8c-1.2-2-4.8-1.3-4.6,1.2c0.9,11.5,4.5,23.2,1.4,34.6 c-0.8,3.1,3.9,4.4,4.7,1.3c2.7-10.1,0.6-20.1-0.7-30.1c2.7,0.9,5.6,0.2,7.9-1.8c0.4,0.9,1.1,1.7,2.4,2.2c1.3,0.5,2.5,0.4,3.6,0 c-1.1,5.2-1.6,10.4-1.3,15.8c0.1,3.2,5.1,3.2,4.9,0c-0.3-6.8,0.5-13.3,2.6-19.7C60.8,36.7,58.3,35.4,56.5,36.2z'/> </svg>",
                  type: "svg",
                },
              ],
            },
            {
              xs: "12",
              sm: "12",
              md: "9",
              lg: "9",
              blocks: [
                {
                  value: "<h1>Smarter <svg version='1.1' class='annotation iconHome slideIcon hideSmall' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 92.9 117.4'> <path style='fill:#000FFF;' d='M83.2,54.3c-2.7,4.1-6,7.5-9.7,10.6c-3.6,3-8,5.8-10.1,10.1c-3.1,6.3-3.3,11.6-10.7,14 c-3.8,1.2-7.7,2-11.5,2.8c-0.2,0-0.3,0.1-0.5,0.1c1.4,0.3,2.8,0.6,4.1,0.9c3.7,0.8,9.9,0.7,12.3,4c0.7,0.9,0.4,2.5-0.4,3.3 c-2.5,2.3-6.7,1.4-9.9,1.6c-1.4,0.1-2.7,0.2-4.1,0.3c2.3,0.5,4.7,0.9,6.9,1.7c3.1,1.1,5.1,4.9,2.5,7.7c-3.6,3.9-13.7,3.5-18.5,2.9 c-3.4-0.4-3.4-5.9,0-5.4c2.9,0.4,5.8,0.3,8.8-0.1c0.5-0.1,1.2-0.3,1.9-0.5c-1.4-0.4-2.7-0.9-3.4-1.1c-4-0.9-10.7-1-13.3-4.5 c-0.8-1-0.3-2.5,0.4-3.3c2-2.3,6.6-2.2,9.8-2.4c-3.5-0.4-8.3-0.9-10.2-3.2c-1-1.2-1-2.6,0-3.8c1.8-2.2,6.3-2.2,8.9-2.7 c3.7-0.8,7.5-1.6,11.2-2.5c2.9-0.7,6-1.1,7.7-3.8c1.9-3.2,2.2-7.1,4.2-10.3c4.4-6.8,12.4-10.5,17.3-16.9c5.5-7.2,8.5-16.5,6.7-25.5 C79.8,8.1,57.8,6.8,41.2,8.7c-9.1,1-18.3,4-24.7,10.9c-6.2,6.8-9,16.6-7.5,25.7c1.7,9.5,7.3,15.6,14.8,21.1c5.4,4,9.4,9.3,8,16.3 c-0.7,3.4-5.9,2-5.2-1.4C28,74.1,20,70.7,15.5,67c-4-3.3-7.1-7.6-9.2-12.3c-4.1-9.2-4-19.6-0.1-28.8C13.8,8.1,32.6,3,50.3,2.7 c8.9-0.1,18.4,0.6,26.2,5.4c7.4,4.6,11.7,12.4,12.9,20.8C90.5,37.8,88.1,46.8,83.2,54.3z M56.5,36.2c-1.9,0.8-3,2.4-4.8,0.2 c-0.3-0.3-0.7-1.9-0.9-2.3c-1-2.1-3.8-1.2-4.5,0.6c-1.3,3.4-5.4,3.9-7.2,0.8c-1.2-2-4.8-1.3-4.6,1.2c0.9,11.5,4.5,23.2,1.4,34.6 c-0.8,3.1,3.9,4.4,4.7,1.3c2.7-10.1,0.6-20.1-0.7-30.1c2.7,0.9,5.6,0.2,7.9-1.8c0.4,0.9,1.1,1.7,2.4,2.2c1.3,0.5,2.5,0.4,3.6,0 c-1.1,5.2-1.6,10.4-1.3,15.8c0.1,3.2,5.1,3.2,4.9,0c-0.3-6.8,0.5-13.3,2.6-19.7C60.8,36.7,58.3,35.4,56.5,36.2z'/> </svg> Proposals</h1>",
                  type: "html",
                },
                {
                  format: "p",
                  value: "A cloud-based proposal platform built by sales pros.",
                  type: "text",
                },
              ],
            },
            {
              xs: "1",
              sm: "1",
              md: "1",
              lg: "1",
              class: "start-xs start-sm center-md center-lg flex flexCenterLg",
              blocks: [],
            },
          ],
        },
      ],
    },
    {
      stack: [
        {
          menu: true,
          title: "Greeting",
          link: "greeting",
          bg: "https://firebasestorage.googleapis.com/v0/b/use-captiv.appspot.com/o/2-hello.svg?alt=media&token=0e877c97-7293-49aa-93fd-a441ffafe5bb",
          cols: [
            {
              xs: "0",
              sm: "0",
              md: "1",
              lg: "1",
              class: "",
              blocks: [],
            },
            {
              xs: "12",
              sm: "12",
              md: "10",
              lg: "8",
              blocks: [
                {
                  format: "strong",
                  value: "What do our digital proposals do?",
                  type: "text",
                },
                {
                  value:
                    "<svg version='1.1' class='arrow inline hideSmall' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 225.3 66.3'> <path style='fill:#000FFF;' d='M223.9,26.6c-0.2,0-0.4,0-0.6,0.1c-0.1,0-0.2,0-0.4,0c0.2-0.5,0.1-0.7-0.1-1 c-0.2-0.5-0.7-0.8-1.2-0.9c-2-0.6-22.4-11.1-34.8-24.3c-0.6-0.6-1.5-0.6-2.1-0.1c-0.6,0.6-0.6,1.5-0.1,2.1 c10.7,11.3,27.2,21,33.9,24.2c-0.9,0-1.8,0-2.9,0c0-0.3-0.1-0.5-0.3-0.8c-0.5-0.6-1.5-0.8-2.1-0.2c-0.3,0.2-0.7,0.6-1.1,1 C175.4,27.1,59,27.2,1.5,27.2c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5c25.1,0,81.3,0,132.6-0.1c26.8,0,48-0.1,63-0.2 c4.8,0,9,0,12.7-0.1c-7.1,9.6-19.9,31.4-21.6,34.3c-0.4,0.7-0.2,1.5,0.4,2c0.3,0.2,0.6,0.3,0.9,0.3c0.4,0,0.8-0.2,1.1-0.5 c0.1-0.1,8.2-9.6,16.1-19c7.9-9.4,12.1-14.4,14.2-17.1c0.4,0,0.7,0,1,0c2.2,0,3.3-0.1,3.3-1.5C225.3,27.4,224.7,26.7,223.9,26.6z M200.1,50c5-8.1,10.4-16.5,13.5-20.2c1.1,0,2.1,0,3,0c0.2,0,0.3,0,0.4,0C213.3,34.3,206.8,42.1,200.1,50z'/> </svg>",
                  type: "svg",
                },
                {
                  format: "p",
                  value: "Captiv’s digital proposal platform enables you to: ",
                  type: "text",
                },
                
                {
                  format: "ul",
                  value: [
                    "Create interactive, buyer-first experiences to boost sales",
                    "Gain granular insights with behavioral tracking",
                    "Save a ton of time",
                  ],
                  type: "list",
                },
                {
                  format: "p",
                  value: " ",
                  type: "text",
                },
                {
                  format: "p",
                  value: "This demo will show you examples of what it can do.",
                  type: "text",
                },
                {
                  value:
                    "<svg version='1.1' class='arrow hideLarge' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 225.3 66.3'> <path style='fill:#000FFF;' d='M223.9,26.6c-0.2,0-0.4,0-0.6,0.1c-0.1,0-0.2,0-0.4,0c0.2-0.5,0.1-0.7-0.1-1 c-0.2-0.5-0.7-0.8-1.2-0.9c-2-0.6-22.4-11.1-34.8-24.3c-0.6-0.6-1.5-0.6-2.1-0.1c-0.6,0.6-0.6,1.5-0.1,2.1 c10.7,11.3,27.2,21,33.9,24.2c-0.9,0-1.8,0-2.9,0c0-0.3-0.1-0.5-0.3-0.8c-0.5-0.6-1.5-0.8-2.1-0.2c-0.3,0.2-0.7,0.6-1.1,1 C175.4,27.1,59,27.2,1.5,27.2c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5c25.1,0,81.3,0,132.6-0.1c26.8,0,48-0.1,63-0.2 c4.8,0,9,0,12.7-0.1c-7.1,9.6-19.9,31.4-21.6,34.3c-0.4,0.7-0.2,1.5,0.4,2c0.3,0.2,0.6,0.3,0.9,0.3c0.4,0,0.8-0.2,1.1-0.5 c0.1-0.1,8.2-9.6,16.1-19c7.9-9.4,12.1-14.4,14.2-17.1c0.4,0,0.7,0,1,0c2.2,0,3.3-0.1,3.3-1.5C225.3,27.4,224.7,26.7,223.9,26.6z M200.1,50c5-8.1,10.4-16.5,13.5-20.2c1.1,0,2.1,0,3,0c0.2,0,0.3,0,0.4,0C213.3,34.3,206.8,42.1,200.1,50z'/> </svg>",
                  type: "svg",
                },
              ],
            },
            {
              xs: "1",
              sm: "1",
              md: "1",
              lg: "1",
              class: "",
              blocks: [],
            },
          ],
        },
      ],
    },
    {
      stack: [
        {
          menu: true,
          title: "Quote",
          link: "quote",
          bg: "https://firebasestorage.googleapis.com/v0/b/use-captiv.appspot.com/o/4-quote.svg?alt=media&token=c687d7af-ceab-4807-8e63-f09dcaa1550c",
          cols: [
            {
              xs: "1",
              sm: "1",
              md: "1",
              lg: "1",
              class: "",
              blocks: [],
            },
            {
              xs: "12",
              sm: "12",
              md: "8",
              lg: "8 ",
              blocks: [
                {
                  format: "small",
                  value: "Did you know?",
                  type: "text",
                  class: "white",
                },
                {
                  format: "blockquote",
                  value: "\“Organizations utilizing sales enablement tools that track engagement have cut their sales cycles by 18%\”",
                  type: "text",
                },
                {
                  format: "p",
                  value: "- Abberdeen",
                  type: "text",
                  class: "citation",
                },
                {
                  format: "div",
                  value: "",
                  type: "text",
                  class: "quoteBar",
                }
              ],
            },
            {
              xs: "1",
              sm: "1",
              md: "1",
              lg: "1",
              class: "",
              blocks: [],
            },
          ],
        },
      ],
    },
    {
      stack: [
        {
          menu: true,
          title: "Product",
          link: "product",
          bg: "https://firebasestorage.googleapis.com/v0/b/use-captiv.appspot.com/o/5-product.jpg?alt=media&token=e694279b-db21-4be8-993a-880eb653fb6e",
          cols: [
            {
              xs: "1",
              sm: "1",
              md: "1",
              lg: "1",
              class: "hideSmall",
              blocks: [],
            },
            {
              xs: "2",
              sm: "2",
              md: "1",
              lg: "1",
              class: "flexCenter",
              blocks: [
                {
                  type: "svg",
                  value: "<svg version='1.1' class='iconArrowDown' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 68.9 124.8'> <path style='fill:#000FFF;' d='M67.2,82.9c-0.6-0.6-1.5-0.6-2.1-0.1C53.7,93.6,43.9,110.3,40.9,117c0-0.9,0-1.9,0-3 c0.3,0,0.6-0.1,0.8-0.3c0.6-0.5,0.8-1.5,0.2-2.1c-0.3-0.3-0.6-0.7-1.1-1.1c-0.1-14.6-0.1-41.4,0-69.2c0-12.7,0-25.8,0-38.6 c0-0.8-0.7-1.5-1.5-1.5c-0.8,0-1.5,0.7-1.5,1.5c0,12.8,0,25.9,0,38.6c0,21.5,0,41.8,0,56.6c0,3.9,0,7.2,0,10.1 c-9.6-7.1-31.3-19.9-34.2-21.6c-0.7-0.4-1.5-0.2-2,0.4s-0.3,1.5,0.2,2c0.1,0.1,9.6,8.2,19,16.1c9.3,7.9,14.3,12,17.1,14.1 c0,0.5,0,1,0,1.4c0.1,1.9,0.1,3.1,1.5,3.2c0,0,0,0,0,0c0.3,0,1.4-0.1,1.6-1.5c0-0.3,0-0.5-0.1-0.8c0-0.1,0-0.2,0-0.3 c0.2,0.1,0.3,0.1,0.5,0.1c0.2,0,0.4-0.1,0.6-0.2c0.5-0.2,0.8-0.7,0.9-1.2c0.6-2,11.1-22.4,24.3-34.8C67.8,84.5,67.8,83.6,67.2,82.9z M17.7,98.4c8.1,5,16.4,10.3,20.2,13.4c0,1.3,0,2.4,0,3.4C33.2,111.5,25.5,105,17.7,98.4z'/> </svg>",
                }
              ],
            },
            {
              xs: "9",
              sm: "9",
              md: "9",
              lg: "8",
              blocks: [
                {
                  format: "h2",
                  value: "Immersive Product Slides",
                  type: "text",
                  class: "white",
                },
                {
                  format: "p",
                  value: "Vertical product or solution slides are useful for adding detail underneath a high level horizontal slide, like this.",
                  type: "text",
                  class: "white",
                },
              ],
            },
            {
              xs: "1",
              sm: "1",
              md: "1",
              lg: "1",
              class: "",
              blocks: [],
            },
          ],
        },
        {
          menu: true,
          title: "Product 1",
          link: "product-1",
          bg: "https://firebasestorage.googleapis.com/v0/b/use-captiv.appspot.com/o/5-product-1.jpg?alt=media&token=88cd05cb-a27f-4fa4-a8ad-9f7b840c2cee",
          cols: [
            {
              xs: "2",
              sm: "2",
              md: "1",
              lg: "1",
              class: "",
              blocks: [],
            },
            {
              xs: "8",
              sm: "8",
              md: "5",
              lg: "5",
              class: "productContain productImageCon",
              blocks: [
                {
                  format: "img",
                  value: "https://firebasestorage.googleapis.com/v0/b/use-captiv.appspot.com/o/product-1.png?alt=media&token=2ccf2f0e-ab39-4452-aaeb-f4ae86e5f149",
                  type: "image",
                  class: "productImage",
                },
              ],
            },
            {
              xs: "2",
              sm: "2",
              md: "1",
              lg: "1",
              class: "hideLarge",
              blocks: [],
            },
            {
              xs: "2",
              sm: "2",
              md: "1",
              lg: "1",
              class: "hideLarge",
              blocks: [],
            },
            {
              xs: "8",
              sm: "8",
              md: "5",
              lg: "5",
              class: "productContain productDesc",
              blocks: [
                {
                  format: "p",
                  value: "Space X",
                  type: "text",
                  class: "white",
                },
                {
                  format: "h3",
                  value: "UNISEX MOTO JACKET",
                  type: "text",
                  class: "white",
                },
                {
                  format: "ul",
                  value: [
                    "Price: $150.00.",
                    "Color: Black.", 
                    "Sizes: XS / S / M / L / XL",
                  ],
                  type: "list",
                  class: "white hideSmall",
                },
                {
                  format: "p",
                  value: " ",
                  type: "text",
                  class: "white",
                },
              ],
            },
            {
              xs: "1",
              sm: "1",
              md: "1",
              lg: "1",
              class: "",
              blocks: [],
            },
          ],
        },
        {
          menu: true,
          title: "Product 2",
          link: "product-2",
          bg: "https://firebasestorage.googleapis.com/v0/b/use-captiv.appspot.com/o/5-product-2.jpg?alt=media&token=89badeb0-294c-4b43-ab33-df523d5c46c0",
          cols: [
            {
              xs: "2",
              sm: "2",
              md: "1",
              lg: "1",
              class: "",
              blocks: [],
            },
            {
              xs: "8",
              sm: "8",
              md: "5",
              lg: "5",
              class: "productContain productImageCon",
              blocks: [
                {
                  format: "img",
                  value: "https://firebasestorage.googleapis.com/v0/b/use-captiv.appspot.com/o/product-2.png?alt=media&token=7e0de022-6683-4dde-bd4a-0d4d056950b6",
                  type: "image",
                  class: "productImage",
                },
              ],
            },
            {
              xs: "2",
              sm: "2",
              md: "1",
              lg: "1",
              class: "hideLarge",
              blocks: [],
            },
            {
              xs: "2",
              sm: "2",
              md: "1",
              lg: "1",
              class: "hideLarge",
              blocks: [],
            },
            {
              xs: "8",
              sm: "8",
              md: "5",
              lg: "5",
              class: "productContain productDesc",
              blocks: [
                {
                  format: "p",
                  value: "Space X",
                  type: "text",
                  class: "white",
                },
                {
                  format: "h3",
                  value: "WOMEN'S DEMO 2 JACKET",
                  type: "text",
                  class: "white",
                },
                {
                  format: "ul",
                  value: [
                    "Price: $100.00.",
                    "Color: Black/White", 
                    "Sizes: S / M / L / XL / 2X",
                  ],
                  type: "list",
                  class: "white hideSmall",
                },
                {
                  format: "p",
                  value: " ",
                  type: "text",
                  class: "white",
                },
              ],
            },
            {
              xs: "1",
              sm: "1",
              md: "1",
              lg: "1",
              class: "",
              blocks: [],
            },
          ],
        },
        {
          menu: true,
          title: "Product 3",
          link: "product-3",
          bg: "https://firebasestorage.googleapis.com/v0/b/use-captiv.appspot.com/o/5-product-3.jpg?alt=media&token=13471660-3218-40bc-a57d-0bb90c896c66",
          cols: [
            {
              xs: "2",
              sm: "2",
              md: "1",
              lg: "1",
              class: "",
              blocks: [],
            },
            {
              xs: "8",
              sm: "8",
              md: "5",
              lg: "5",
              class: "productContain productImageCon",
              blocks: [
                {
                  format: "img",
                  value: "https://firebasestorage.googleapis.com/v0/b/use-captiv.appspot.com/o/product-3.png?alt=media&token=f16e8ab4-3bfc-4ce0-bf90-7aadd1632a4b",
                  type: "image",
                  class: "productImage",
                },
              ],
            },
            {
              xs: "2",
              sm: "2",
              md: "1",
              lg: "1",
              class: "hideLarge",
              blocks: [],
            },
            {
              xs: "2",
              sm: "2",
              md: "1",
              lg: "1",
              class: "hideLarge",
              blocks: [],
            },
            {
              xs: "8",
              sm: "8",
              md: "5",
              lg: "5",
              class: "productContain productDesc",
              blocks: [
                {
                  format: "p",
                  value: "Space X",
                  type: "text",
                  class: "white",
                },
                {
                  format: "h3",
                  value: "UNISEX TRACK JACKET",
                  type: "text",
                  class: "white",
                },
                {
                  format: "ul",
                  value: [
                    "Price: $40.00.",
                    "Color: Grey", 
                    "Sizes: XS / S / M / L / XL",
                  ],
                  type: "list",
                  class: "white hideSmall",
                },
                {
                  format: "p",
                  value: " ",
                  type: "text",
                  class: "white",
                },
              ],
            },
            {
              xs: "1",
              sm: "1",
              md: "1",
              lg: "1",
              class: "",
              blocks: [],
            },
          ],
        },
      ],
    },
    {
      stack: [
        {
          menu: true,
          title: "Touch",
          link: "touch",
          bg: "https://firebasestorage.googleapis.com/v0/b/use-captiv.appspot.com/o/use-bg_3-touch.svg?alt=media&token=0d94ddf7-c84e-41b2-b425-68e77a1481a2",
          cols: [
            {
              xs: "1",
              sm: "1",
              md: "1",
              lg: "1",
              class: "",
              blocks: [],
            },
            {
              xs: "12",
              sm: "12",
              md: "10",
              lg: "8",
              blocks: [
                {
                  format: "svg",
                  value: "<svg version='1.1' class='slideIcon' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 126.7 106.3'> <circle style='opacity:0.5;fill:#00B500;' cx='53' cy='53.2' r='51.5'/> <circle style='opacity:0.5;fill:#00B500;' cx='73' cy='53.2' r='41.8'/> <circle style='fill:#00B500;' cx='93' cy='53.2' r='32.2'/> </svg>",
                  type: "svg",
                },
                {
                  format: "h2",
                  value: "Touch Optimized",
                  type: "text",
                },
                {
                  format: "p",
                  value: "Stand out from the crowd with guided proposals that are easy to use and look great on a computer or touch devices, like mobile phones. ",
                  type: "text",
                },
                {
                  format: "span",
                  value: "Buyers simply ",
                  type: "text",
                  class: "hideSmall black",
                },
                {
                  format: "span",
                  value: "swipe through your slides.",
                  type: "text",
                  class: "hideSmall underline black"
                },
                {
                  format: "span",
                  value: "Simply swipe through slides.",
                  type: "text",
                  class: "hideLarge underline black",
                },
              ],
            },
            {
              xs: "1",
              sm: "1",
              md: "1",
              lg: "1",
              class: "",
              blocks: [],
            },
          ],
        },
      ],
    },
    {
      stack: [
        {
          menu: true,
          title: "Unlimited Interactivity",
          link: "interactivity",
          bg: "https://firebasestorage.googleapis.com/v0/b/use-captiv.appspot.com/o/6-features.svg?alt=media&token=c7ee4897-fbd5-4117-a573-de824822d741",
          cols: [
            {
              xs: "1",
              sm: "1",
              md: "1",
              lg: "1",
              class: "",
              blocks: [],
            },
            {
              xs: "12",
              sm: "12",
              md: "10",
              lg: "8",
              blocks: [
                {
                  format: "h2",
                  value: "Unlimited Interactivity",
                  type: "text",
                },
                {
                  format: "p",
                  value: "Integrate anything. Convert more deals with: ",
                  type: "text",
                },
                {
                  format: "ul",
                  value: [
                    "Automated click-throughs",
                    "Embedded surveys",
                    "Data visualizations",
                    "Videos",
                    "Downloadable attachments",
                    "eSignature",
                  ],
                  type: "list",
                  class: "liChecks",
                  ulClass: "ulChecks",
                },
              ],
            },
            {
              xs: "1",
              sm: "1",
              md: "1",
              lg: "1",
              class: "",
              blocks: [],
            },
          ],
        },
      ],
    },
    {
      stack: [
        {
          menu: true,
          title: "Chat",
          link: "chat",
          bg: "https://firebasestorage.googleapis.com/v0/b/use-captiv.appspot.com/o/7-chat.svg?alt=media&token=ee49abde-62a8-4b54-827b-ac13b9ef1918",
          cols: [
            {
              xs: "1",
              sm: "1",
              md: "1",
              lg: "1",
              class: "",
              blocks: [],
            },
            {
              xs: "12",
              sm: "12",
              md: "10",
              lg: "8",
              blocks: [
                {
                  value: "<svg version='1.1' class='right annotation slideIconLg' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 257.4 104.4'> <path style='fill:#000FFF;' d='M191.9,103.6c-2.8,0-5.1-1.1-6.4-3c-7.3-11-15.8-21.5-23.9-31.6c-1.1-1.4-2.2-2.8-3.4-4.2 c-22.5,0.6-129.3,1.3-148.6,0.3C6,65,3.5,62.4,3.3,58.9c-0.6-12.5-1.1-18-1.5-22.4C1.3,30.4,0.9,26.4,0.8,9c0-4.7,6.2-7.4,9.5-7.5 c48.1-1.4,187.4-0.7,235.5,0.2c6.6,0.1,8.1,3.5,8.3,6.3c0,0,0,0,0,0c0.5,12.7,1,17.6,1.4,21.5c0.5,5.1,0.9,8.7,0.9,24.8 c0,4.9-6.1,7-9.3,7.4c-5.9,0.8-11.9,0.6-17.7,0.4c-5.1-0.2-10.4-0.4-15.5,0.1c-2.7,1.6-7.9,21.1-9.9,28.5c-1,3.6-1.7,6.1-2,7.2 c-1.2,3.3-5.3,5.2-8.6,5.6C192.8,103.6,192.3,103.6,191.9,103.6z M158.9,61.8c0.5,0,0.9,0.2,1.2,0.6c1.3,1.6,2.5,3.2,3.8,4.7 c8.2,10.2,16.7,20.7,24.1,31.8c0.8,1.2,2.7,1.8,4.9,1.6c2.8-0.3,5.5-1.9,6.2-3.7c0.3-0.9,1-3.5,2-6.9c6.2-23.1,9.1-30.3,12.4-30.6 c5.3-0.6,10.8-0.4,16-0.2c5.7,0.2,11.6,0.4,17.2-0.3c2.2-0.3,6.8-1.8,6.7-4.5c-0.1-15.9-0.4-19.5-0.9-24.5c-0.4-4-0.9-8.9-1.4-21.7 c-0.1-1.6-0.8-3.3-5.3-3.4c-48-0.9-187.2-1.6-235.3-0.2C8.2,4.6,3.8,6.5,3.8,9c0.1,17.3,0.5,21.3,1,27.3c0.4,4.4,0.9,10,1.5,22.5 c0.1,2,1.4,3.3,3.5,3.4C28.6,63.1,138.7,62.4,158.9,61.8C158.9,61.8,158.9,61.8,158.9,61.8z'/> </svg>",
                  type: "svg",
                },
                {
                  format: "h2",
                  value: "Built-in chat",
                  type: "text",
                },
                {
                  format: "p",
                  value: "Keep your prospects engaged and reduce friction at key decision points. As questions surface or key milestones are crossed, keep your customers in the loop.",
                  type: "text",
                },
              ],
            },
            {
              xs: "1",
              sm: "1",
              md: "1",
              lg: "1",
              class: "",
              blocks: [],
            },
          ],
        },
      ],
    },
    {
      stack: [
        {
          menu: true,
          title: "Voiceover Audio",
          link: "audio",
          bg: "https://firebasestorage.googleapis.com/v0/b/use-captiv.appspot.com/o/8-vo.svg?alt=media&token=f054da23-3c30-470d-9fd4-5da92c4555b8",
          cols: [
            {
              xs: "1",
              sm: "1",
              md: "1",
              lg: "1",
              class: "hideSmall",
              blocks: [],
            },
            {
              xs: "10",
              sm: "10",
              md: "10",
              lg: "8",
              blocks: [
                {
                  format: "h2",
                  value: "Voiceover Audio",
                  type: "text",
                  class: "inlineBlock",
                },
                {
                  value: "<svg version='1.1' class='inlineBlock annotation slideIcon voIcon hideSmall' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 68.9 124.8'> <path style='fill:#000FFF;' d='M2.4,105.6c-0.5,0-0.9-0.2-1.2-0.6c-0.5-0.7-0.4-1.6,0.3-2.1c18.1-13.7,22.1-28.5,22.3-38.5 c0.3-17.7-11-29.4-22-40.8l-0.5-0.5c-0.6-0.6-0.6-1.5,0-2.1C2,20.4,3,20.4,3.5,21L4,21.5c11.4,11.8,23.1,24,22.8,42.9 c-0.2,10.7-4.4,26.5-23.5,40.9C3.1,105.5,2.8,105.6,2.4,105.6z M18.7,113.8c16.7-12.1,28.2-33,28.5-52.1c0.4-22-13.9-36.3-27.7-50.1 L18.8,11c-0.6-0.6-1.5-0.6-2.1,0c-0.6,0.6-0.6,1.5,0,2.1l0.6,0.6c13.4,13.4,27.2,27.2,26.8,48c-0.3,18.1-11.3,38.1-27.2,49.7 c-0.7,0.5-0.8,1.4-0.3,2.1c0.3,0.4,0.8,0.6,1.2,0.6C18.1,114,18.4,113.9,18.7,113.8z M35,123.4C54.5,109,67.9,84.2,68.2,61.6 C68.7,35.4,52,18.4,35.9,2l-0.7-0.7c-0.6-0.6-1.5-0.6-2.1,0c-0.6,0.6-0.6,1.5,0,2.1l0.7,0.7c15.7,16,31.9,32.5,31.5,57.4 c-0.4,21.7-13.2,45.6-32,59.5c-0.7,0.5-0.8,1.4-0.3,2.1c0.3,0.4,0.7,0.6,1.2,0.6C34.5,123.7,34.8,123.6,35,123.4z'/> </svg>",
                  type: "svg",
                }
              ],
            },
            {
              xs: "2",
              sm: "2",
              md: "1",
              lg: "1",
              class: "hideLarge",
              blocks: [
                {
                  value: "<svg version='1.1' class='inlineBlock annotation slideIcon voIconSmall' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 68.9 124.8'> <path style='fill:#000FFF;' d='M2.4,105.6c-0.5,0-0.9-0.2-1.2-0.6c-0.5-0.7-0.4-1.6,0.3-2.1c18.1-13.7,22.1-28.5,22.3-38.5 c0.3-17.7-11-29.4-22-40.8l-0.5-0.5c-0.6-0.6-0.6-1.5,0-2.1C2,20.4,3,20.4,3.5,21L4,21.5c11.4,11.8,23.1,24,22.8,42.9 c-0.2,10.7-4.4,26.5-23.5,40.9C3.1,105.5,2.8,105.6,2.4,105.6z M18.7,113.8c16.7-12.1,28.2-33,28.5-52.1c0.4-22-13.9-36.3-27.7-50.1 L18.8,11c-0.6-0.6-1.5-0.6-2.1,0c-0.6,0.6-0.6,1.5,0,2.1l0.6,0.6c13.4,13.4,27.2,27.2,26.8,48c-0.3,18.1-11.3,38.1-27.2,49.7 c-0.7,0.5-0.8,1.4-0.3,2.1c0.3,0.4,0.8,0.6,1.2,0.6C18.1,114,18.4,113.9,18.7,113.8z M35,123.4C54.5,109,67.9,84.2,68.2,61.6 C68.7,35.4,52,18.4,35.9,2l-0.7-0.7c-0.6-0.6-1.5-0.6-2.1,0c-0.6,0.6-0.6,1.5,0,2.1l0.7,0.7c15.7,16,31.9,32.5,31.5,57.4 c-0.4,21.7-13.2,45.6-32,59.5c-0.7,0.5-0.8,1.4-0.3,2.1c0.3,0.4,0.7,0.6,1.2,0.6C34.5,123.7,34.8,123.6,35,123.4z'/> </svg>",
                  type: "svg",
                }
              ],
            },
          ],
        },
      ],
    },
    {
      stack: [
        {
          menu: true,
          title: "Powerful Analytics",
          link: "analytics",
          bg: "https://firebasestorage.googleapis.com/v0/b/use-captiv.appspot.com/o/9-analytics.svg?alt=media&token=9f3203d6-5e30-434a-9e20-5afcc8a495c2",
          cols: [
            {
              xs: "1",
              sm: "1",
              md: "1",
              lg: "1",
              class: "hideSmall",
              blocks: [],
            },
            {
              xs: "12",
              sm: "12",
              md: "10",
              lg: "10",
              blocks: [
                {
                  format: "h2",
                  value: "Powerful Analytics",
                  type: "text",
                },
                {
                  format: "p",
                  value: "We’re tracking your current session now.",
                  type: "text",
                },
              ]
            },
            {
              xs: "1",
              sm: "1",
              md: "1",
              lg: "1",
              class: "hideSmall",
              blocks: [],
            },
            {
              xs: "2",
              sm: "2",
              md: "1",
              lg: "1",
              class: "iconArrowCurl",
              blocks: [
                {
                  type: "svg",
                  format: "svg",
                  value: "<svg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px'viewBox='0 0 73.8 228.1' style='enable-background:new 0 0 73.8 228.1;' xml:space='preserve'> <path style='fill:#000FFF;' d='M71.5,209.3c-1.6-2.3-16-32.9-18.2-40.8c-0.2-0.8-1.1-1.3-1.9-1c-0.8,0.2-1.3,1.1-1,1.9 c1.5,5.4,13.6,32.7,17.9,40.3c-0.2,0.1-0.3,0.1-0.5,0.2c0.1-0.2,0.1-0.5,0.1-0.8c-0.1-0.8-0.9-1.4-1.7-1.2c-0.3,0.1-0.8,0.2-1.3,0.3 c0-0.6-0.3-1.1-0.9-1.4c-32.4-15.3-55.3-50-58.2-88.4C4.3,98.3,8.3,77.9,17.5,59.5C27.9,38.9,44.4,20.8,66.6,5.8 c0.7-0.5,0.9-1.4,0.4-2.1c-0.4-0.7-1.3-0.9-2-0.4C42.3,18.6,25.4,37.1,14.9,58.2C5.4,77.1,1.3,98,2.8,118.6 c3,39.1,26.1,74.4,59,90.4c-10.8,3.4-34.4,12.5-35.6,13c-0.7,0.3-1.1,1.1-0.9,1.9c0.2,0.6,0.8,1,1.4,1c0.1,0,0.3,0,0.4-0.1 c0.1,0,11-3.1,21.8-6.2c20.6-6,22.7-6.6,22.9-8.1C72,210.1,71.8,209.6,71.5,209.3z'/> </svg>"
                }
              ],
            },
            {
              xs: "10",
              sm: "10",
              md: "9",
              lg: "8",
              blocks: [
                {
                  format: "p",
                  value: " ",
                  type: "text",
                },
                {
                  format: "p",
                  value: "Enter your email to receive YOUR tracking summary of what you can expect on prospect’s behavior for smarter follow-ups and context-driven conversations.",
                  type: "text",
                },
                {
                  type: "form",
                  format: "div",
                  fields: [
                    {
                      format: "input",
                      placeholder: "Work Email",
                      type: "input",
                      class: "loginEmail",
                      id: "loginEmail",
                    },
                    {
                      format: "button",
                      placeholder: "",
                      value: "Request Report",
                      type: "button",
                      id: "loginEmailBtn",
                    }
                  ]
                },
                {
                  format: "p",
                  value: "Thanks",
                  type: "personal",
                  class: "hide colorSuccess",
                  id: "emailCaptureSuccess",
                },
                {
                  format: "p",
                  value: "Please enter a valid email address",
                  type: "text",
                  class: "hide colorError",
                  id: "emailCaptureError",
                },
              ],
            },
            {
              xs: "1",
              sm: "1",
              md: "1",
              lg: "1",
              class: "",
              blocks: [],
            },
          ],
        },
      ],
    },
    {
      stack: [
        {
          menu: true,
          title: "Send without worry",
          link: "password",
          bg: "https://firebasestorage.googleapis.com/v0/b/use-captiv.appspot.com/o/10-pass.svg?alt=media&token=3df1661e-5475-41b1-80c2-67472e42a294",
          cols: [
            {
              xs: "1",
              sm: "1",
              md: "1",
              lg: "1",
              class: "",
              blocks: [],
            },
            {
              xs: "12",
              sm: "12",
              md: "6",
              lg: "6",
              blocks: [
                {
                  format: "svg",
                  value: "<svg version='1.1' class='slideIcon hideLarge' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 143.7 152.4'> <path style='fill:#000FFF;' d='M125.1,63.7c0-2.5-0.1-4.1-0.1-4.3c0-0.4-0.2-0.9-0.5-1.2c-0.4-0.4-1.2-1.1-14.8-1.4V50 c0-3.7-1.4-13-6.7-21.5c-4.7-7.4-13.9-16.3-31.2-16.3c-32.1,0-38.8,33-38.8,39.5v6.2c-3.4,0-6.3,0-8.5,0c-2.7,0-4.4-0.1-5.2,0.1 C18.6,58,18,58.7,18,59.4v78.5c0,0.4,0.2,0.8,0.5,1.1c0.6,0.6,1.2,1.2,27.4,1.2c0.9,0,1.9,0,2.9,0l51.8-0.5c0,0,0,0,0,0 c8.9-0.1,16.1-0.2,19.9-0.3c1.8,0,2.9,0,3,0c0.4,0,0.8-0.2,1.1-0.5C125.4,138.2,126.2,137.4,125.1,63.7z M36,51.7 c0-6,6.2-36.5,35.8-36.5c33.4,0,34.9,34.4,34.9,34.8v6.8c-3.6-0.1-7.9-0.1-13.1-0.1c-18-0.1-37.7,0.3-51.5,1 C40,57.7,38,57.8,36,57.8V51.7z M122.4,136.5c-0.5,0-1.1,0-1.9,0c-3.9,0.1-11.1,0.2-19.9,0.3l-51.8,0.5c-19.4,0-25.7-0.3-27.8-0.5 V60.8c0.9,0,2.1,0,3.5,0c4.1,0,10.4,0.1,17.8-0.2c29.7-1.5,73-1.2,79.8-0.2c0,0.8,0,1.9,0,3.3C122.9,115.8,122.7,132.5,122.4,136.5z M72.6,87.5c0.5,0.5,1.4,1.5,0.3,22.3c0,0.8-0.7,1.4-1.5,1.4c0,0-0.1,0-0.1,0c-0.8,0-1.5-0.7-1.4-1.6c0.5-8.6,0.7-18.3,0.3-20.2 c-0.2-0.3-0.3-0.6-0.3-0.9c0-0.8,0.7-1.5,1.5-1.5C71.8,87,72.3,87.2,72.6,87.5z'/> </svg>",
                  type: "svg",
                },
                {
                  format: "h2",
                  value: "Send without worry",
                  type: "text",
                },
                {
                  format: "p",
                  value: "Don’t you hate when your proposals get in the wrong hands, like competitors.",
                  type: "text",
                },
                {
                  format: "p",
                  value: "Set a password that viewers will need to enter for an additional layer of security. Clawback your proposal anytime to make changes in real-time or disable all together.",
                  type: "text",
                },
              ],
            },
            {
              xs: "2",
              sm: "2",
              md: "2",
              lg: "2",
              class: "hideSmall",
              blocks: [],
            },
            {
              xs: "12",
              sm: "12",
              md: "3",
              lg: "3",
              class: "hideSmall textCenter",
              blocks: [
                {
                  format: "svg",
                  value: "<svg version='1.1' class='slideIcon textCenter' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 143.7 152.4'> <path style='fill:#000FFF;' d='M125.1,63.7c0-2.5-0.1-4.1-0.1-4.3c0-0.4-0.2-0.9-0.5-1.2c-0.4-0.4-1.2-1.1-14.8-1.4V50 c0-3.7-1.4-13-6.7-21.5c-4.7-7.4-13.9-16.3-31.2-16.3c-32.1,0-38.8,33-38.8,39.5v6.2c-3.4,0-6.3,0-8.5,0c-2.7,0-4.4-0.1-5.2,0.1 C18.6,58,18,58.7,18,59.4v78.5c0,0.4,0.2,0.8,0.5,1.1c0.6,0.6,1.2,1.2,27.4,1.2c0.9,0,1.9,0,2.9,0l51.8-0.5c0,0,0,0,0,0 c8.9-0.1,16.1-0.2,19.9-0.3c1.8,0,2.9,0,3,0c0.4,0,0.8-0.2,1.1-0.5C125.4,138.2,126.2,137.4,125.1,63.7z M36,51.7 c0-6,6.2-36.5,35.8-36.5c33.4,0,34.9,34.4,34.9,34.8v6.8c-3.6-0.1-7.9-0.1-13.1-0.1c-18-0.1-37.7,0.3-51.5,1 C40,57.7,38,57.8,36,57.8V51.7z M122.4,136.5c-0.5,0-1.1,0-1.9,0c-3.9,0.1-11.1,0.2-19.9,0.3l-51.8,0.5c-19.4,0-25.7-0.3-27.8-0.5 V60.8c0.9,0,2.1,0,3.5,0c4.1,0,10.4,0.1,17.8-0.2c29.7-1.5,73-1.2,79.8-0.2c0,0.8,0,1.9,0,3.3C122.9,115.8,122.7,132.5,122.4,136.5z M72.6,87.5c0.5,0.5,1.4,1.5,0.3,22.3c0,0.8-0.7,1.4-1.5,1.4c0,0-0.1,0-0.1,0c-0.8,0-1.5-0.7-1.4-1.6c0.5-8.6,0.7-18.3,0.3-20.2 c-0.2-0.3-0.3-0.6-0.3-0.9c0-0.8,0.7-1.5,1.5-1.5C71.8,87,72.3,87.2,72.6,87.5z'/> </svg>",
                  type: "svg",
                },
                {
                  format: "p",
                  value: "",
                  type: "text",
                },
                {
                  type: "form",
                  format: "div",
                  fields: [
                    {
                      format: "input",
                      placeholder: "Password",
                      type: "input",
                      class: "loginEmail",
                      id: "loginPassword",
                    },
                    {
                      format: "button",
                      placeholder: "",
                      value: "Access Proposal",
                      type: "button",
                      id: "loginPasswordBtn",
                    }
                  ]
                },
                {
                  format: "p",
                  value: "Success!",
                  type: "text",
                  class: "hide colorSuccess textCenter fullWidth",
                  id: "passwordSuccess",
                },
              ],
            },
            {
              xs: "1",
              sm: "1",
              md: "1",
              lg: "1",
              class: "",
              blocks: [],
            },
          ],
        },
      ],
    },
    {
      stack: [
        {
          menu: true,
          title: "Print",
          link: "print",
          bg: "https://firebasestorage.googleapis.com/v0/b/use-captiv.appspot.com/o/11-pdf.svg?alt=media&token=57f43a96-bd4c-40a2-8cad-41030954597c",
          cols: [
            {
              xs: "1",
              sm: "1",
              md: "1",
              lg: "1",
              class: "",
              blocks: [],
            },
            {
              xs: "12",
              sm: "12",
              md: "6",
              lg: "6",
              blocks: [
                {
                  format: "svg",
                  value: "<svg version='1.1' class='slideIcon hideLarge' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 143.7 152.4'> <path style='fill:#000FFF;' d='M141.4,36c0-2.4-0.1-4-0.1-4.2c0-0.4-0.2-0.8-0.5-1.1c-0.6-0.6-1.3-1.2-28.7-0.7V3.8 c0-0.4-0.1-1.3-1.5-1.7C106.6,1,79.3,1.8,71,2c-8.9,0.3-17.7,0.6-24.2,1C35.2,3.7,35,4,34.5,4.8c-0.3,0.5-0.3,1.1,0,1.6 c0.5,1.8,0.3,14.1-0.2,25.7c-0.5,0-1.1,0-1.6,0.1c-16.3,0.6-27.4,1.1-29.9,1.3c-0.8,0.1-1.4,0.7-1.4,1.5v73.3c0,0.4,0.2,0.8,0.5,1.1 c0.7,0.7,1.2,1.2,35.7,1.2c0.6,0,1.2,0,1.8,0c-1,3.3-2.1,6.9-3.2,10.5c-8.4,27.6-7.8,28.2-6.9,29.1c0.3,0.3,0.8,0.8,11.2,0.8 c6.8,0,17.7-0.2,35.5-0.8c45.2-1.4,46.3-2.5,46.8-3c0.3-0.3,0.4-0.7,0.4-1.1c0-0.3-0.1-0.7-0.3-1c-0.7-1.3-3.9-11.5-6.7-20.5 c-1.8-5.9-3.3-10.7-4.6-14.5c10.7-0.1,19.4-0.2,24.2-0.3c2.4,0,3.8,0,4,0c0.4,0,0.8-0.2,1.1-0.5C141.8,108.5,142.9,107.4,141.4,36z M37.6,6.7c9-1,63.6-3.1,71.6-1.9v25.1c-2.6,0-5.4,0.1-8.4,0.2c-21,0.5-45.7,1.2-63.4,1.9C38.1,16,37.9,9.5,37.6,6.7z M119.7,145.1 c-11.3,1.3-78.1,3.4-87.7,2.7c1-5.9,9.4-33.5,15.2-51.4h56.6c1.6,3,6.4,18.7,9.7,29.2C117,137.2,118.7,142.5,119.7,145.1z M138.7,106.8c-0.7,0-1.7,0-2.9,0c-4.9,0.1-14,0.2-25.1,0.3c-4.5-13.7-5-13.8-6.3-13.8H46c-0.7,0-1.2,0.4-1.4,1 c0,0.1-1.8,5.7-4.2,13.2c-25.1,0-33.4-0.3-35.9-0.5V36.4c4-0.3,14.5-0.7,28.4-1.2c27.5-1,56.8-1.8,77.8-2.2c0,0,0,0,0,0c0,0,0,0,0,0 c14.2-0.2,24.5-0.3,27.7,0c0,0.7,0,1.8,0.1,3.1C139.5,88.9,139.1,103.4,138.7,106.8z M119.5,76.9c0.3,0.3,0.5,0.7,0.5,1.1V91 c0,0.8-0.7,1.5-1.5,1.5S117,91.8,117,91V79.2c-4-0.6-22-0.9-80.9,0.3c-2.7,0.1-4.5,0.1-5.3,0.1c-0.4,1.3,0.2,5.4,0.6,7.6 c0.3,2,0.6,3.9,0.6,5.2c0,0.8-0.7,1.5-1.5,1.5s-1.5-0.7-1.5-1.5c0-1.1-0.3-2.9-0.5-4.8c-0.8-5.3-1.1-8.7,0.2-10.2 c0.5-0.5,1.1-0.8,1.8-0.8c0.4,0,2.4,0,5.6-0.1C117.3,74.8,118.6,76,119.5,76.9z M41.5,57h-15c-0.8,0-1.5-0.7-1.5-1.5 s0.7-1.5,1.5-1.5h15c0.8,0,1.5,0.7,1.5,1.5S42.4,57,41.5,57z M50.6,22.2C50.2,21.9,50,21.4,50,21c0-0.8,0.7-1.5,1.5-1.5 c0.4,0,0.8,0.2,1.1,0.5c3.4,1,27,0.3,43.1-0.5c0.9,0,1.5,0.6,1.6,1.4s-0.6,1.5-1.4,1.6c-0.1,0-10.7,0.5-21.4,0.8 c-4.7,0.1-8.5,0.2-11.5,0.2C51.9,23.5,51.1,22.7,50.6,22.2z M50.6,113.2c-0.3-0.3-0.5-0.8-0.5-1.2c0-0.8,0.7-1.5,1.5-1.5 c0.4,0,0.8,0.2,1.1,0.5c3.2,0.9,25.2,0.4,44.9-0.5c0.9,0,1.5,0.6,1.6,1.4c0,0.8-0.6,1.5-1.4,1.6c-0.1,0-11.1,0.5-22.3,0.8 c-4.9,0.1-8.8,0.2-12,0.2C51.9,114.4,51.1,113.7,50.6,113.2z M104.3,129.9c0.9,0,1.5,0.6,1.6,1.4c0,0.8-0.6,1.5-1.4,1.6 c-0.1,0-14.4,0.7-28.7,1.2c-11.2,0.4-18.2,0.6-22.7,0.6c-7.4,0-7.8-0.4-8.2-0.8c-0.3-0.3-0.5-0.7-0.5-1.1c0-0.8,0.7-1.5,1.5-1.5 c0.3,0,0.6,0.1,0.8,0.3C50.5,132.2,83.8,130.9,104.3,129.9z'/> </svg>",
                  type: "svg",
                },
                {
                  format: "h2",
                  value: "Export to PDF",
                  type: "text",
                },
                {
                  format: "p",
                  value: "We get it, there's still a need to print. Proposals can be exported to PDF and printed. ",
                  type: "text",
                },
              ],
            },
            {
              xs: "2",
              sm: "2",
              md: "2",
              lg: "2",
              class: "hideSmall",
              blocks: [],
            },
            {
              xs: "12",
              sm: "12",
              md: "3",
              lg: "3",
              class: "hideSmall textCenter",
              blocks: [
                {
                  format: "svg",
                  value: "<svg version='1.1' class='slideIcon textCenter' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 143.7 152.4'> <path style='fill:#000FFF;' d='M141.4,36c0-2.4-0.1-4-0.1-4.2c0-0.4-0.2-0.8-0.5-1.1c-0.6-0.6-1.3-1.2-28.7-0.7V3.8 c0-0.4-0.1-1.3-1.5-1.7C106.6,1,79.3,1.8,71,2c-8.9,0.3-17.7,0.6-24.2,1C35.2,3.7,35,4,34.5,4.8c-0.3,0.5-0.3,1.1,0,1.6 c0.5,1.8,0.3,14.1-0.2,25.7c-0.5,0-1.1,0-1.6,0.1c-16.3,0.6-27.4,1.1-29.9,1.3c-0.8,0.1-1.4,0.7-1.4,1.5v73.3c0,0.4,0.2,0.8,0.5,1.1 c0.7,0.7,1.2,1.2,35.7,1.2c0.6,0,1.2,0,1.8,0c-1,3.3-2.1,6.9-3.2,10.5c-8.4,27.6-7.8,28.2-6.9,29.1c0.3,0.3,0.8,0.8,11.2,0.8 c6.8,0,17.7-0.2,35.5-0.8c45.2-1.4,46.3-2.5,46.8-3c0.3-0.3,0.4-0.7,0.4-1.1c0-0.3-0.1-0.7-0.3-1c-0.7-1.3-3.9-11.5-6.7-20.5 c-1.8-5.9-3.3-10.7-4.6-14.5c10.7-0.1,19.4-0.2,24.2-0.3c2.4,0,3.8,0,4,0c0.4,0,0.8-0.2,1.1-0.5C141.8,108.5,142.9,107.4,141.4,36z M37.6,6.7c9-1,63.6-3.1,71.6-1.9v25.1c-2.6,0-5.4,0.1-8.4,0.2c-21,0.5-45.7,1.2-63.4,1.9C38.1,16,37.9,9.5,37.6,6.7z M119.7,145.1 c-11.3,1.3-78.1,3.4-87.7,2.7c1-5.9,9.4-33.5,15.2-51.4h56.6c1.6,3,6.4,18.7,9.7,29.2C117,137.2,118.7,142.5,119.7,145.1z M138.7,106.8c-0.7,0-1.7,0-2.9,0c-4.9,0.1-14,0.2-25.1,0.3c-4.5-13.7-5-13.8-6.3-13.8H46c-0.7,0-1.2,0.4-1.4,1 c0,0.1-1.8,5.7-4.2,13.2c-25.1,0-33.4-0.3-35.9-0.5V36.4c4-0.3,14.5-0.7,28.4-1.2c27.5-1,56.8-1.8,77.8-2.2c0,0,0,0,0,0c0,0,0,0,0,0 c14.2-0.2,24.5-0.3,27.7,0c0,0.7,0,1.8,0.1,3.1C139.5,88.9,139.1,103.4,138.7,106.8z M119.5,76.9c0.3,0.3,0.5,0.7,0.5,1.1V91 c0,0.8-0.7,1.5-1.5,1.5S117,91.8,117,91V79.2c-4-0.6-22-0.9-80.9,0.3c-2.7,0.1-4.5,0.1-5.3,0.1c-0.4,1.3,0.2,5.4,0.6,7.6 c0.3,2,0.6,3.9,0.6,5.2c0,0.8-0.7,1.5-1.5,1.5s-1.5-0.7-1.5-1.5c0-1.1-0.3-2.9-0.5-4.8c-0.8-5.3-1.1-8.7,0.2-10.2 c0.5-0.5,1.1-0.8,1.8-0.8c0.4,0,2.4,0,5.6-0.1C117.3,74.8,118.6,76,119.5,76.9z M41.5,57h-15c-0.8,0-1.5-0.7-1.5-1.5 s0.7-1.5,1.5-1.5h15c0.8,0,1.5,0.7,1.5,1.5S42.4,57,41.5,57z M50.6,22.2C50.2,21.9,50,21.4,50,21c0-0.8,0.7-1.5,1.5-1.5 c0.4,0,0.8,0.2,1.1,0.5c3.4,1,27,0.3,43.1-0.5c0.9,0,1.5,0.6,1.6,1.4s-0.6,1.5-1.4,1.6c-0.1,0-10.7,0.5-21.4,0.8 c-4.7,0.1-8.5,0.2-11.5,0.2C51.9,23.5,51.1,22.7,50.6,22.2z M50.6,113.2c-0.3-0.3-0.5-0.8-0.5-1.2c0-0.8,0.7-1.5,1.5-1.5 c0.4,0,0.8,0.2,1.1,0.5c3.2,0.9,25.2,0.4,44.9-0.5c0.9,0,1.5,0.6,1.6,1.4c0,0.8-0.6,1.5-1.4,1.6c-0.1,0-11.1,0.5-22.3,0.8 c-4.9,0.1-8.8,0.2-12,0.2C51.9,114.4,51.1,113.7,50.6,113.2z M104.3,129.9c0.9,0,1.5,0.6,1.6,1.4c0,0.8-0.6,1.5-1.4,1.6 c-0.1,0-14.4,0.7-28.7,1.2c-11.2,0.4-18.2,0.6-22.7,0.6c-7.4,0-7.8-0.4-8.2-0.8c-0.3-0.3-0.5-0.7-0.5-1.1c0-0.8,0.7-1.5,1.5-1.5 c0.3,0,0.6,0.1,0.8,0.3C50.5,132.2,83.8,130.9,104.3,129.9z'/> </svg>",
                  type: "svg",
                },
                {
                  format: "p",
                  value: "",
                  type: "text",
                },
                {
                  format: "p",
                  value: "Here’s an example:",
                  type: "text",
                  class: "hideSmall textCenter",
                },
                {
                  format: "a",
                  value: "Print Version",
                  action: "/?print-pdf",
                  type: "link",
                  class: "btn hideSmall",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      stack: [
        {
          menu: true,
          title: "Advantage",
          link: "advantage",
          bg: "https://firebasestorage.googleapis.com/v0/b/use-captiv.appspot.com/o/1-cover.svg?alt=media&token=ec26b3c3-9617-4dae-96ea-7963d521d452",
          cols: [
            {
              xs: "1",
              sm: "1",
              md: "1",
              lg: "1",
              class: "",
              blocks: [],
            },
            {
              xs: "12",
              sm: "12",
              md: "10",
              lg: "8",
              blocks: [
                {
                  format: "h2",
                  value: "Ready to Create an Unfair Advantage?",
                  type: "text",
                  class: "headline",
                },
                {
                  format: "a",
                  value: "Quick Chat",
                  type: "link",
                  class: "openChatBtn marginRight15 btn",
                },
                {
                  format: "a",
                  id: "schedule",
                  value: "Schedule a call",
                  type: "link",
                  class: "btn",
                  action: "https://meetings.hubspot.com/captivsales",
                },
              ],
            },
            {
              xs: "1",
              sm: "1",
              md: "1",
              lg: "1",
              class: "",
              blocks: [],
            },
          ],
        },
      ],
    },
  ],
};

export default slidesLocal;
